<script lang="ts">
	import ScrollReveal from '$lib/components/ScrollReveal.svelte';
	import { t, type Language } from '$lib/i18n';

	interface Props {
		lang: Language;
	}

	let { lang }: Props = $props();
	let tr = $derived(t(lang));
</script>

<section class="final-cta py-16 md:py-32 relative overflow-hidden">
	<div
		class="final-cta-bg absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900/50 to-slate-950"
	></div>
	<div class="absolute inset-0 bg-grid opacity-20"></div>

	<!-- Animated orbs (hidden on mobile) -->
	<div
		class="hidden md:block absolute top-1/2 left-1/4 w-64 h-64 bg-ameta-green/10 rounded-full blur-3xl animate-pulse"
	></div>
	<div
		class="hidden md:block absolute top-1/2 right-1/4 w-48 h-48 bg-ameta-green/5 rounded-full blur-3xl animate-pulse"
		style="animation-delay: 1s;"
	></div>

	<div class="relative max-w-4xl mx-auto px-6 text-center">
		<ScrollReveal>
			<h2 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-8">
				{tr('cta_title_1')}
				<span class="text-gradient"> {tr('cta_title_2')}</span>
			</h2>
			<p class="text-xl text-slate-400 mb-12 max-w-2xl mx-auto">
				{tr('cta_subtitle')}
			</p>
			<a href="#contact" class="btn-primary text-lg inline-flex items-center gap-3 glow-green">
				<span>{tr('cta_button')}</span>
				<svg
					aria-hidden="true"
					class="w-5 h-5"
					fill="none"
					stroke="currentColor"
					viewBox="0 0 24 24"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M17 8l4 4m0 0l-4 4m4-4H3"
					/>
				</svg>
			</a>
		</ScrollReveal>
	</div>
</section>
